import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNoLeadingSpaceDirective]'
})
export class NoLeadingSpaceDirectiveDirective {
  constructor(private ngControl: NgControl) { }

  @HostListener('input', ['$event'])
  onInput(event: InputEvent): void {
    const inputElement = event.target as HTMLInputElement;
    const originalValue = inputElement.value;

    // Remove leading spaces but allow everything else
    const updatedValue = originalValue.replace(/^\s+/, '');

    if (originalValue !== updatedValue) {
      this.ngControl.control?.setValue(updatedValue);
    }
  }
}
